// extracted by mini-css-extract-plugin
export default {"statsContainer":"cLiRHwsBDsY8PROqvcxr"};